var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRPdfUnselected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11H13.25V29H26.75V15.5L22.25 11Z",
    fill: "#F4F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11V15.5H26.75L22.25 11Z",
    fill: "#EDB2B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11H13.25V29H26.75V15.5L22.25 11Z",
    stroke: "#262626",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 19.4525H21.5V25.7975H10.625V19.4525Z",
    fill: "#EC4347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 19.4525H21.5V25.7975H10.625V19.4525Z",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11.375V15.5H26.375",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7524 21.29C13.8986 21.2846 14.0443 21.3102 14.1799 21.365C14.2877 21.4072 14.385 21.4725 14.4649 21.5563C14.5383 21.6344 14.5934 21.7279 14.6262 21.83C14.6606 21.9328 14.6783 22.0404 14.6787 22.1488C14.678 22.2571 14.6603 22.3647 14.6262 22.4675C14.5934 22.5696 14.5383 22.6631 14.4649 22.7413C14.3853 22.8263 14.288 22.8928 14.1799 22.9363C14.0434 22.9875 13.8982 23.0117 13.7524 23.0075H13.1337V23.9675H12.5449V21.29H13.7524ZM13.5912 22.55C13.656 22.5557 13.7213 22.5557 13.7862 22.55C13.8446 22.5409 13.9006 22.5206 13.9512 22.49C14.0002 22.4627 14.0396 22.4207 14.0637 22.37C14.0933 22.3053 14.1087 22.2349 14.1087 22.1638C14.1087 22.0926 14.0933 22.0222 14.0637 21.9575C14.0387 21.9064 13.9996 21.8635 13.9512 21.8338C13.8996 21.8061 13.8439 21.7871 13.7862 21.7775C13.7213 21.7719 13.656 21.7719 13.5912 21.7775H13.1337V22.55H13.5912Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2011 21.29C16.3649 21.2878 16.5276 21.3157 16.6811 21.3725C16.8223 21.4275 16.9501 21.5119 17.0561 21.62C17.1701 21.7373 17.2571 21.8781 17.3111 22.0325C17.3829 22.2217 17.4185 22.4227 17.4161 22.625C17.4173 22.8077 17.392 22.9896 17.3411 23.165C17.2955 23.3219 17.2176 23.4675 17.1124 23.5925C17.01 23.714 16.8819 23.8114 16.7374 23.8775C16.5691 23.9487 16.3876 23.9832 16.2049 23.9788H15.0461V21.29H16.2011ZM16.1599 23.4725C16.2441 23.4722 16.3277 23.4583 16.4074 23.4313C16.4883 23.4037 16.5615 23.3574 16.6211 23.2963C16.6885 23.2242 16.7397 23.1385 16.7711 23.045C16.8115 22.9242 16.8305 22.7973 16.8274 22.67C16.8291 22.5438 16.8152 22.4179 16.7861 22.295C16.7645 22.1931 16.721 22.0972 16.6586 22.0138C16.5963 21.9341 16.5133 21.8731 16.4186 21.8375C16.2999 21.7887 16.1718 21.767 16.0436 21.7738H15.6349V23.4613L16.1599 23.4725Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7075 21.29V21.785H18.4137V22.4038H19.5387V22.8613H18.4137V23.9675H17.825V21.29H19.7075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRPdfUnselected);
export default __webpack_public_path__ + "static/media/r-pdf-unselected.f36dfc0fcb799c164ceb9496ac516d41.svg";
export { ForwardRef as ReactComponent };